import React from "react";
import { Card, Tab, Tabs, CardContent } from "@mui/material";
import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { PropertyPageTitle, PropertyPageTitleVariables } from "types/gql-types";
import { AdminHeading } from "../shared/admin-form";
import { createTabPanel } from "../tab-panel";
import PropertyDetails from "./update-container";
import PropertyUseCases from "./use-cases";
import { PROPERTY_PAGE_TITLE } from "./page-queries";

type Props = {
  id?: string;
}

enum TabsIndex {
  Details = 0,
  UseCases = 1,
}

const TabPanel = createTabPanel(
  {
    details: TabsIndex.Details,
    "use-cases": TabsIndex.UseCases,
  },
  "property-tab",
);

const UpdatePropertyPage: React.FC<Props> = ({ id: propId }) => {
  const params = useParams<{ id?: string }>();
  const propertyId = propId ?? params.id;
  const [tabIndex, setTabIndex] = React.useState<TabsIndex>(0);
  const { data: titleData, loading: titleLoading } = useQuery<
  PropertyPageTitle,
  PropertyPageTitleVariables
  >(PROPERTY_PAGE_TITLE, {
    variables: { id: propertyId ?? "" },
    skip: !propertyId,
    fetchPolicy: "cache-and-network",
  });

  if (!propertyId) return <div>Invalid URL</div>;

  const propertyName = titleData?.property?.name;
  const titleContent = titleLoading && !propertyName ? "…" : propertyName || "Property";

  return (
    <>
      <AdminHeading component="h1">{titleContent}</AdminHeading>

      <Tabs value={tabIndex} onChange={(_event, index: TabsIndex) => setTabIndex(index)}>
        <Tab label="Details" />
        <Tab label="Use Cases" />
      </Tabs>

      <Card>
        <CardContent>
          <TabPanel tabIndex={tabIndex} id="details">
            <PropertyDetails propertyId={propertyId} />
          </TabPanel>
          <TabPanel tabIndex={tabIndex} id="use-cases">
            <PropertyUseCases propertyId={propertyId} />
          </TabPanel>
        </CardContent>
      </Card>
    </>
  );
};

export default UpdatePropertyPage;
